import clsx from 'clsx'
import { Icon, TextInput } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/Filters/FilterInput/filter-input.module.scss'

const FilterInput = ({
  noIcon = false,
  name,
  value,
  placeholder = 'filters.input.placeholder',
  handleKeyDown = () => {},
}) => {
  const { t } = useTranslation()

  const [inputVal, setInputVal] = useState(value)

  useEffect(() => {
    setInputVal(value)
  }, [value])

  const handleChange = useCallback(
    (e) => {
      setInputVal(e.target.value)
    },
    [setInputVal],
  )

  return (
    <div className={clsx('filter-input', styles['filter-input'])}>
      <TextInput
        searchInput
        onChange={handleChange}
        value={inputVal}
        onKeyDown={(e) =>
          (e.keyCode === 13 || e.keyCode === 9) &&
          handleKeyDown({ fieldName: name, value: e.target.value })
        }
        variant={'outlined'}
        fullWidth={true}
        placeholder={t(placeholder)}
        InputProps={{
          startAdornment: !noIcon && (
            <Icon name={'search'} color={'Interface-Seventh'} size={'m'} />
          ),
        }}
      />
    </div>
  )
}

FilterInput.propTypes = {
  noIcon: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  handleKeyDown: PropTypes.func,
}

export default FilterInput
